(() => {
  if (window.unewFooterPrivacyBound) return;
  window.unewFooterPrivacyBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-unew-cookie-settings]');
    if (!button) return;
    const error = button.parentElement.querySelector('[role="status"]');
    error.hidden = true;
    button.disabled = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Privacy banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      error.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
})();
